import styled from '@emotion/styled';
import { SHOT_CONFIG } from '../constants/shotConfig';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  max-width: 1280px;
  max-height: 773px;
  gap: 36px;
  padding-top: 20px;
`;

export const DashedBox = styled.div`
  width: 1000px;
  height: 500px;
  position: relative;
  border-radius: 12px;
  border: 4px dashed ${({ theme }) => theme.color[3]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > p:first-of-type {
    ${({ theme }) => theme.typography.SEMI_BOLD_24};
    color: ${({ theme }) => theme.color[2]};
    text-align: center;
    line-height: 24px;
    margin-bottom: 12px;
  }
`;

export const AiLoadingText = styled.h3`
  ${({ theme }) => theme.typography.SEMI_BOLD_48};
  color: ${({ theme }) => theme.color[2]};
  text-align: center;
  margin-bottom: 20px;
`;

export const ShotInfoBox = styled.div`
  display: flex;
  width: 100%;
  gap: 41px;
  padding-left: 146px;
  padding-right: 84px;
`;

export const ShotInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  height: 300px;

  > h3 {
    ${({ theme }) => theme.typography.SEMI_BOLD_48};
    color: ${({ theme }) => theme.color[2]};
    text-align: left;
    line-height: 44px;
  }
  > h3:nth-of-type(1) {
    margin-bottom: 44px;
    margin-top: 58px;
  }
  > h3:nth-of-type(2) {
    margin-bottom: 30px;
  }
  > button {
    position: absolute;
    right: 0;
    bottom: 0;
  }
`;

export const Description = styled.p`
  ${({ theme }) => theme.typography.REGULAR_16};
  color: ${({ theme }) => theme.color[2]};
  text-align: center;
  margin-top: 12px;
`;

export const WebcamWrapper = styled.div`
  video {
    transform: ${SHOT_CONFIG.MIRROR_MODE ? 'scaleX(-1)' : 'none'}; /* MIRROR_MODE 설정에 따라 거울모드 적용 */
  }
`;
